"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const pit_operation_1 = require("services/report/pit-operation");
const pit_operation_types_1 = require("./pit-operation.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pit_operation_1._getReportPitOperation)(dataStates);
    if (response.isError) {
        dispatch({
            type: pit_operation_types_1.reportPitOperationTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        let currNo = 0;
        let currArea = response.data[0].area_name;
        let currContractor = response.data[0].contractor_name;
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map((item) => {
                if (item.contractor_name === currContractor && item.area_name === currArea) {
                    currNo++;
                }
                else {
                    currNo = 1;
                    currArea = item.area_name;
                    currContractor = item.contractor_name;
                }
                return Object.assign(Object.assign({}, item), { no: currNo, modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: pit_operation_types_1.reportPitOperationTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: pit_operation_types_1.reportPitOperationTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: pit_operation_types_1.reportPitOperationTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: pit_operation_types_1.reportPitOperationTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: pit_operation_types_1.reportPitOperationTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: pit_operation_types_1.reportPitOperationTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const exportDocuments = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, pit_operation_1._exportReportPitOperation)(dataStates);
    if (response.isError) {
        dispatch({
            type: pit_operation_types_1.reportPitOperationTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: pit_operation_types_1.reportPitOperationTypes.SET_EXPORT_DOCUMENTS, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: pit_operation_types_1.reportPitOperationTypes.CLEAR_EXPORT_DOCUMENTS, payload: '' });
};
exports.default = {
    getDataGrid,
    onSortChange,
    onCloseError,
    onFilterChange,
    clearDocuments,
    onClickMutation,
    exportDocuments,
    onDataStateChange,
};
